import { ServerSubstitutionKeywordsStringAssets } from "../../../../../assets/stringAssets";

/**
 * @function generateEmailSubjectForSigninWithEmailLink Generates the Subject of a notification email for a sign-in with email link
 * @returns {string} A string with the Subject of the email message to be sent.
 */
export function generateEmailSubjectForSigninWithEmailLink(): string {

  // *** Compose the email Subject ***
  const emailSubject = `(${ServerSubstitutionKeywordsStringAssets.ProjectName}) Sign-in with Email Link`;

  // return the email content
  return emailSubject;
}
